import { jsx as _jsx } from "react/jsx-runtime";
import { HorizontalProductCardEditable, } from './HorizontalProductCardEditable';
import { HorizontalProductCardReadOnly, } from './HorizontalProductCardReadOnly';
export const HorizontalProductCard2 = (props) => {
    const { editable } = props;
    return editable ? (_jsx(HorizontalProductCardEditable, { ...props })) : (_jsx(HorizontalProductCardReadOnly, { ...props }));
};
